import React from "react";
import { HashRouter, Routes, Route } from "react-router-dom";
import { LayoutHome } from "../layout/LayoutHome";
import { Home } from "../pages/Home";
import { NotFound } from "../pages/NotFound";
import { PageProductById } from "../pages/PageProductById";
import { PathRoot } from "./types";

export const AppRouter = () => {
	return (
		<>
			<HashRouter>
				<Routes>
					<Route path={PathRoot.root} element={<LayoutHome />}>
						<Route index element={<Home />} />
						<Route path={PathRoot.product} element={<PageProductById />} />
					</Route>
					<Route path={PathRoot.notfound} element={<NotFound />} />
				</Routes>
			</HashRouter>
		</>
	);
};
